import React from "react";
import HeroSection from "../components/sections/Hero/HeroSection";
import AboutSection from "../components/sections/About/AboutSection";
import ProductsSection from "../components/sections/Products/ProductsSection";
import ServicesSection from "../components/sections/Services/ServicesSection";
import ReferencesSection from "../components/sections/References/ReferencesSection";
import ContactSection from "../components/sections/Contact/ContactSection";

const Home: React.FC = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <ServicesSection />
      <ReferencesSection />
      <ContactSection />
    </>
  );
};

export default Home;